import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { Place, PlaceFormPayload } from 'types/place'
import { mergeURL } from './lib'
import { serialize } from 'object-to-formdata'

const resource = 'places'

export const requests = {
  fetchPlaces: () => {
    return axiosForGigbaseBiz.get<DataResponse<Place[]>>(resource)
  },
  fetchIndex: async (page: number, limit: number) => {
    return await axiosForGigbaseBiz.get<DataResponse<Place[]>>(resource, {
      params: {
        page,
        limit,
      },
    })
  },
  fetchDetail: async (id: string) => {
    return await axiosForGigbaseBiz.get<DataResponse<Place>>(
      mergeURL(resource, id.toString()),
    )
  },
  create: async (payload: PlaceFormPayload) => {
    return await axiosForGigbaseBiz.post<DataResponse>(
      resource,
      serialize(payload),
    )
  },
  update: async (id: string, payload: PlaceFormPayload) => {
    return await axiosForGigbaseBiz.patch<DataResponse<Place>>(
      mergeURL(resource, id.toString()),
      serialize(payload),
    )
  },
}
